'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var LINE_BREAK = exports.LINE_BREAK = {
  NORMAL: 'normal',
  STRICT: 'strict'
};

var parseLineBreak = exports.parseLineBreak = function parseLineBreak(wordBreak) {
  switch (wordBreak) {
    case 'strict':
      return LINE_BREAK.STRICT;

    case 'normal':
    default:
      return LINE_BREAK.NORMAL;
  }
};